import { DropdownOption } from '../../types/shared/DropdownOption';

export const reverseEnum = (baseEnum: { [key: string]: number }): { [key: number]: string } => {
    const reversed: { [key: number]: string } = {};
    Object.entries(baseEnum).forEach(([key, value]) => {
        reversed[value] = key;
    });
    return reversed;
};

export function enumKeys<O extends Record<string, unknown>, K extends keyof O = keyof O>(
    obj: O,
): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
}

export enum userRoles {
    superAdmin = 5,
    admin = 10,
    user = 20,
    // crud admins
    admins = 30,
    challengeGroups = 50,
    challengeTags = 60,
    // crud users
    users = 90,
    contactUsMessages = 100,
    assessor = 110,
    challengeHolder = 120,
    challengeView = 130,
    // challenge calendar
    calendar = 140,
}

export const userRoleNames = {
    [userRoles.superAdmin]: 'Super Admin',
    [userRoles.admin]: 'Admin',
    [userRoles.user]: 'User',
    [userRoles.admins]: 'Admins',
    [userRoles.challengeGroups]: 'Challenge Groups',
    [userRoles.challengeTags]: 'Challenge Tags',
    [userRoles.users]: 'Users',
    [userRoles.contactUsMessages]: 'Contact Us Messages',
    [userRoles.assessor]: 'Assessor',
    [userRoles.challengeHolder]: 'Challenge Holder',
    [userRoles.challengeView]: 'Challenge View',
    [userRoles.calendar]: 'Calendar',
};

interface SuperAdminRolesEnumModel {
    superAdmin: number;
    admin: number;
}
interface UserDropdownEnumModel {
    basic: number;
}

export const convertEnumToDropdownOption = (
    enums: SuperAdminRolesEnumModel | UserDropdownEnumModel,
): DropdownOption<number>[] => {
    const filteredArr: DropdownOption<number>[] = [];

    Object.entries(enums).forEach(([key, value]) => {
        if (typeof value === 'number') {
            filteredArr.push({
                value: value,
                label: key.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
                    return str.toUpperCase();
                }),
            });
        }
        return;
    });

    return filteredArr;
};

export const convertEnumCustomLabelsToDropdownOption = (
    enumToConvert: Record<string, string>,
): DropdownOption<number>[] => {
    const converted = Object.keys(enumToConvert).map(key => {
        const label = enumToConvert[key];

        return {
            label,
            value: +key,
        };
    });

    return converted;
};
